import React from "react";
import { Flex, Box } from "rebass";
import styled from "styled-components";
import { Avatar } from "../common/Avatar";
import { getLocalizedString } from "../../utils";

const UnavailableSize = styled(Box)`
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 1px solid #ffffff80;
  background-color: #f04836;
`;
const ColorItem = styled(Box)`
  background-color: #8b6113;
  font-size: 20px;
  color: white;
  padding: 8px 21px;
`;
const ColorText = styled(Box)`
  font-size: 20px;
  text-transform: uppercase;
  margin: 8px 20px;
`;
const ColorVariant = () => {
  return (
    <Flex
      width={1}
      flexDirection="column"
      style={{
        marginTop: "15px",
      }}
    >
      <Box width={1}>
        <Flex>
          <ColorItem>2310</ColorItem>
          <ColorText>chantilly</ColorText>
          <ColorItem>1021</ColorItem>
          <ColorText>purple</ColorText>
        </Flex>
      </Box>
      <Box width={1} style={{ marginTop: "20px" }}>
        <Flex width={1} flexDirection="row">
          <Flex
            width={2 / 3}
            style={{
              backgroundColor: "#FFFFFF16",
              borderTop: "2px solid #FFFFFF20",
              borderBottom: "2px solid #FFFFFF20",
              padding: "18px",
              fontSize: "20px",
            }}
          >
            <Box width={1 / 6}>SIZE</Box>
            <Flex width={5 / 6}>
              <Box width={1 / 10} key="36">
                36
              </Box>
              <Box width={1 / 10} key="38">
                38
              </Box>
              <Box width={1 / 10} key="40">
                40
              </Box>
              <Box width={1 / 10} key="42">
                42
              </Box>
              <Box width={1 / 10} key="44">
                44
              </Box>
              <Box width={1 / 10} key="46">
                46
              </Box>
              <Box width={1 / 10} key="48">
                48
              </Box>
              <Box width={1 / 10} key="50">
                50
              </Box>
              <Box width={1 / 10} key="52">
                52
              </Box>
              <Box width={1 / 10} key="54">
                54
              </Box>
            </Flex>
          </Flex>
          <Flex
            width={1 / 3}
            style={{
              backgroundColor: "#FFFFFF20",
              borderTop: "2px solid #FFFFFF20",
              borderBottom: "2px solid #FFFFFF20",
              padding: "18px",
            }}
          >
            <Box width={1 / 2}>{getLocalizedString("QUANTITA'")}</Box>
            <Box width={1 / 2}>{getLocalizedString("TOTALE")}</Box>
          </Flex>
        </Flex>
      </Box>
      <Box width={1}>
        <Flex width={1} flexDirection="row">
          <Flex
            width={2 / 3}
            style={{
              backgroundColor: "#FFFFFF16",
              borderBottom: "2px solid #FFFFFF20",
              padding: "18px",
              fontSize: "20px",
            }}
          >
            <Box width={1 / 6}>Available</Box>
            <Flex width={5 / 6}>
              <Box width={1 / 10} key="36">
                <UnavailableSize justifyContent="center" />
              </Box>
              <Box width={1 / 10} key="38">
                <UnavailableSize justifyContent="center" />
              </Box>
              <Box width={1 / 10} key="40">
                <UnavailableSize justifyContent="center" />
              </Box>
              <Box width={1 / 10} key="42">
                <UnavailableSize justifyContent="center" />
              </Box>
              <Box width={1 / 10} key="44">
                <UnavailableSize justifyContent="center" />
              </Box>
              <Box width={1 / 10} key="46">
                <UnavailableSize justifyContent="center" />
              </Box>
              <Box width={1 / 10} key="48">
                8
              </Box>
              <Box width={1 / 10} key="50">
                2
              </Box>
              <Box width={1 / 10} key="52">
                <UnavailableSize justifyContent="center" />
              </Box>
              <Box width={1 / 10} key="54">
                <UnavailableSize justifyContent="center" />
              </Box>
            </Flex>
          </Flex>
          <Flex
            width={1 / 3}
            style={{
              backgroundColor: "#FFFFFF20",
              borderBottom: "2px solid #FFFFFF20",
              padding: "18px",
            }}
          >
            <Box width={1 / 2}>10</Box>
            <Box width={1 / 2}></Box>
          </Flex>
        </Flex>
      </Box>
      <Box width={1}>
        <Flex width={1} flexDirection="row">
          <Flex
            width={2 / 3}
            style={{
              backgroundColor: "#FFFFFF16",
              borderBottom: "2px solid #FFFFFF20",
              padding: "18px",
              fontSize: "20px",
            }}
          >
            <Box width={1 / 6}>
              <Avatar name="J P" size={30} />
            </Box>
            <Flex width={5 / 6}>
              <Box width={1 / 10} key="36">
                -
              </Box>
              <Box width={1 / 10} key="38">
                -
              </Box>
              <Box width={1 / 10} key="40">
                -
              </Box>
              <Box width={1 / 10} key="42">
                -
              </Box>
              <Box width={1 / 10} key="44">
                -
              </Box>
              <Box width={1 / 10} key="46">
                -
              </Box>
              <Box width={1 / 10} key="48">
                -
              </Box>
              <Box width={1 / 10} key="50">
                1
              </Box>
              <Box width={1 / 10} key="52">
                -
              </Box>
              <Box width={1 / 10} key="54">
                -
              </Box>
            </Flex>
          </Flex>
          <Flex
            width={1 / 3}
            style={{
              backgroundColor: "#FFFFFF20",
              borderBottom: "2px solid #FFFFFF20",
              padding: "18px",
            }}
          >
            <Box width={1 / 2}>1</Box>
            <Box width={1 / 2}>350</Box>
          </Flex>
        </Flex>
      </Box>
    </Flex>
  );
};

export { ColorVariant };
